import React, { forwardRef } from 'react';

const InputText = forwardRef(({
    label,
    error,
    className = '',
    id,
    type = 'text',
    ...props
}, ref) => {
    return (
        <div className="flex flex-col gap-1.5">
            {label && (
                <label
                    htmlFor={id}
                    className="text-sm font-medium text-gray-700"
                >
                    {label}
                </label>
            )}
            <input
                ref={ref}
                id={id}
                type={type}
                className={`
                    flex h-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm placeholder:text-gray-400 
                    focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent 
                    disabled:cursor-not-allowed disabled:opacity-50
                    ${error ? 'border-red-500 focus:ring-red-500' : ''}
                    ${className}
                `}
                {...props}
            />
            {error && (
                <span className="text-sm text-red-500">{error.message}</span>
            )}
        </div>
    );
});

InputText.displayName = "InputText";

export default InputText;